import React from 'react'
import DocumentsImage from "../../assets/images/documents-stashfin.webp"

const DocumentsRequired = () => {
  return (
    <section id="documents" className='documents'>
      <div className='heading'>
        What should you keep <br />handy before applying to Stashfin?
      </div>
      <div className='sub-heading'>
        Keep a copy of the following documents handy <br />on your phone before applying to Stashfin
      </div>
      <div className='doc-img'>
        <img src={DocumentsImage} alt="Documents required |Stashfin" loading='lazy' />
      </div>
    </section>
  )
}

export default DocumentsRequired
